const checkStatusEditable = (submissionStatus, sampleSpecFlag = null, submissionEventId = "") => {
  // If submissionEventId is provided and not an empty string, disable actions
  if (submissionEventId) {
    return false;
  }

  const submissionEditable = submissionStatus && parseInt(submissionStatus) === -1;
  if (sampleSpecFlag !== null) {
    const sampleEditable = sampleSpecFlag && (parseInt(sampleSpecFlag) <= -1 && parseInt(sampleSpecFlag) >= -2);
    return submissionEditable && sampleEditable;
  }
  return submissionEditable;
};

/** Retest sample: parent_sample is a non-null, non-empty object */
export const sampleHasParentSample = (sample) => (
  Boolean(sample && sample.parent_sample && Object.keys(sample.parent_sample).length > 0)
);

export const submissionHasRetestSample = (submission) => (
  (submission && submission.samples_list ? submission.samples_list : []).some(sampleHasParentSample)
);

export default checkStatusEditable;
